import React from 'react'
import SelectTableFilter from 'components/atoms/select-table-filter'
import RowButton from 'components/atoms/row-button'
import CustomerOrderShipmentStatusBadge from 'domains/customer-order/atoms/shipment-status-badge'
import PriceUtil from 'utils/price-util'
import { ITEM_STATUS, SHIPMENT_STATUS } from 'domains/customer-order/constants'
import PropTypes from 'prop-types'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const propTypes = {
  handleSelectRow    : PropTypes.func,
  isShipmentItems    : PropTypes.bool,
  selectedOrderItems : PropTypes.arrayOf(PropTypes.object)
}

const defaultProps = {
  handleSelectRow    : () => {},
  isShipmentItems    : false,
  selectedOrderItems : []
}

const customerOrderCreateShipmentTableColumns = (
  handleSelectRow,
  isShipmentItems,
  chosenOrderItems
) => {
  // Custom Filter
  // Used to modify the filter in specific columns
  // eslint-disable-next-line react/prop-types
  const StatusFilter = ({ column }) => {
    const options = Object.keys(SHIPMENT_STATUS).map((key) => (
      {
        label : SHIPMENT_STATUS[key],
        value : SHIPMENT_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // Custom Cell
  // Used to modify the cell in specific columns
  const ImageCell  = (row) => <img style={{ width: '8rem' }} src={ row.cell.value } alt={ row.row.original.name }/>
  const PriceCell  = (row) => PriceUtil.format(row.cell.value)
  const WeightCell = (row) => row.cell.value + ' gr'
  const StatusCell = (row) => <CustomerOrderShipmentStatusBadge status={ row.cell.value } />

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {
    // eslint-disable-next-line react/prop-types
    const data = row.original

    const color   = isShipmentItems ? 'danger' : 'primary'
    const onClick = isShipmentItems ? () => handleSelectRow(data, 'remove') : () => handleSelectRow(data, 'add')
    const text    = isShipmentItems ? 'Remove' : 'Add to Shipment'

    // conditional since we're using the same columns for shipment items and order items
    const disabled = chosenOrderItems
      ? chosenOrderItems.some((item) => (item.id === data.id))
      : false

    const isCancelledOrderItem = data.status === ITEM_STATUS.CANCELLED

    return (
      <RowButton
        data={ data }
        color={ color }
        onClick={ onClick }
        text={ text }
        disabled={ disabled || isCancelledOrderItem }
      />
    )}
  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header         : 'Image',
        accessor       : 'image',
        disableFilters : true,
        Cell           : ImageCell
      },
      {
        Header   : 'SKU',
        accessor : 'sku'
      },
      {
        Header         : 'Type',
        accessor       : 'productable_type',
        disableFilters : true
      },
      {
        Header   : 'Name',
        accessor : 'name'
      },
      {
        Header         : 'Qty',
        accessor       : 'quantity',
        disableFilters : true
      },
      {
        Header         : 'Price',
        accessor       : 'price',
        disableFilters : true,
        Cell           : PriceCell
      },
      {
        Header: <>
          <div>Weight</div>
          <div>(grams)</div>
        </>,
        accessor       : 'weight',
        disableFilters : true,
        Cell           : WeightCell
      },
      {
        Header   : 'Status',
        accessor : 'status',
        Filter   : StatusFilter,
        Cell     : StatusCell
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

customerOrderCreateShipmentTableColumns.propTypes    = propTypes
customerOrderCreateShipmentTableColumns.defaultProps = defaultProps

export default customerOrderCreateShipmentTableColumns